import moment from "moment";
import { axiosGet, axiosPost } from "../../../react_axios/Axios";
import { getExhibitorDetailsReportUrl, getReportListUrl, GET_REPORT_LIST, GET_EXHIBITOR_DETAILS_REPORT, getReceiptReportUrl, GET_RECEIPT_REPORT, getTaxInvoiceReportUrl, GET_TAX_INVOICE_REPORT, headers,getExhibitorFinalRankReportUrl,GET_EXHIBITOR_FINAL_RANK_REPORT, getTruckTrackerReportUrl, GET_TRUCK_TRACKER_REPORT } from "../../../utils/constants";

export const getExhibitorDetailsReport_action = (exhibitionID, ExhRegistrationID) => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: exhibitionID,
            ExhRegistrationID: ExhRegistrationID
        }
        console.log("getVisaInvitation_action Action------->", params)

        const res = await axiosGet(getExhibitorDetailsReportUrl, params, headers)

        dispatch({
            type: GET_EXHIBITOR_DETAILS_REPORT,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const getReportList_action = () => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: JSON.parse(sessionStorage.getItem("sessionExhibitionID")),
        }
        console.log("getVisaInvitation_action Action------->", params)

        const res = await axiosGet(getReportListUrl, params, headers)

        dispatch({
            type: GET_REPORT_LIST,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const getReceiptReport_action = (exhibitionID, ExhRegistrationID) => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: exhibitionID,
            ExhRegistrationID: ExhRegistrationID
        }
        console.log("getVisaInvitation_action Action------->", params)

        const res = await axiosGet(getReceiptReportUrl, params, headers)

        dispatch({
            type: GET_RECEIPT_REPORT,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const getTaxInvoiceReport_action = (exhibitionID, ExhRegistrationID) => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: exhibitionID,
            ExhRegistrationID: ExhRegistrationID
        }
        console.log("getVisaInvitation_action Action------->", params)

        const res = await axiosGet(getTaxInvoiceReportUrl, params, headers)

        dispatch({
            type: GET_TAX_INVOICE_REPORT,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

// the report screen uses '' for "never touched" and 'select' for the placeholder
// option; ExhRegistrationID additionally uses 0 for "All". sp_EntryExitTruckTrack
// treats every optional parameter as "no filter" only when it is NULL, so all
// three have to collapse to null before they leave the browser.
const unsetToNull = (value) =>
    value === '' || value === null || value === undefined || value === false || value === 'select' || value === 0 || value === '0'
        ? null
        : value

export const getTruckTrackerReport_action = (exhibitionID, ExhRegistrationID, nonEmpanelVendorID, fromDate, toDate, truckNo, gateID, hallID, statusID) => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: exhibitionID,
            ExhRegistrationID: unsetToNull(ExhRegistrationID),
            NonEmpanelVendorID: unsetToNull(nonEmpanelVendorID),
            // the range picker hands back Date objects; format from the local
            // parts so a date never slips a day on the way to a SQL DATE
            FromDate: fromDate != null ? moment(fromDate).format('YYYY-MM-DD') : null,
            ToDate: toDate != null ? moment(toDate).format('YYYY-MM-DD') : null,
            TruckNo: unsetToNull(truckNo != null ? String(truckNo).trim() : truckNo),
            GateID: unsetToNull(gateID),
            HallID: unsetToNull(hallID),
            StatusID: unsetToNull(statusID)
        }

        const res = await axiosGet(getTruckTrackerReportUrl, params, headers)

        dispatch({
            type: GET_TRUCK_TRACKER_REPORT,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const getExhibitorFinalRankReport_action = (exhibitionID, ExhRegistrationID) => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: exhibitionID,
            ExhRegistrationID: ExhRegistrationID
        }

        const res = await axiosGet(getExhibitorFinalRankReportUrl, params, headers)

        dispatch({
            type: GET_EXHIBITOR_FINAL_RANK_REPORT,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}